import { Spinner } from '@heroui/spinner';

export default function Loading() {
  return (
    <div className="relative z-10 flex h-[60vh] w-full items-center justify-center">
      <Spinner classNames={{ label: 'text-[#333] text-sm mt-2' }} label="加载中..." variant="simple" />
    </div>
  );
}
